import { AccountStarOutlineIcon } from './AccountStarOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 3B63C1BC-9FB2-4F41-86CF-93D6117585E9
 * name account-star-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-star-outline.svg
 * tags
 * - Account / User 
 */
export const UserStarOutlineIcon = AccountStarOutlineIcon;
export default UserStarOutlineIcon